<app-page-header 
  title="Anmeldung" 
  subtitle="Melden Sie sich mit Ihrem Kundenkonto an" 
  icon="key" 
  variant="gradient">
</app-page-header>

<div class="login-container nlc-container nlc-fade-in">
  <div class="login-card">
    <div class="card-content">
      <div class="card-header">
        <mat-icon class="card-icon" matPrefix>account_circle</mat-icon>
        <div class="card-title">
          <h2 class="nlc-heading-1">Kundenanmeldung</h2>
          <p>Bestehende Kunden mit registrierten Konten</p>
        </div>
      </div>
      <p class="card-description">
        Verwenden Sie Ihre E-Mail und Ihr Passwort, um auf Ihr Kundenkonto zuzugreifen.
      </p>
      <div class="features-list">
        <div class="feature-item">
          <div class="feature-icon">
            <mat-icon>check</mat-icon>
          </div>
          <span class="feature-text">Aufträge und Transaktionen ansehen</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <mat-icon>check</mat-icon>
          </div>
          <span class="feature-text">Coin-Guthaben verwalten</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <mat-icon>check</mat-icon>
          </div>
          <span class="feature-text">Kundensupport kontaktieren</span>
        </div>
      </div>
      <button class="login-btn" (click)="navigateToCustomerLogin()">
        <mat-icon>login</mat-icon>
        Kundenanmeldung
      </button>
    </div>
    <div class="card-footer">
      <div class="footer-links">
        <a href="/register" class="footer-link">
          Noch kein Konto? <strong>Jetzt registrieren</strong>
        </a>
      </div>
    </div>
  </div>
</div>